import { useSyncExternalStore } from 'react';

/** Tailwind's `lg` breakpoint, for layouts that change what a tab contains, not just how it looks. */
export const LG_QUERY = '(min-width: 64rem)';

const media = (query: string) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = media(query);
      list?.addEventListener('change', onChange);
      return () => list?.removeEventListener('change', onChange);
    },
    () => media(query)?.matches ?? false,
    () => false
  );
}
